<template>
  <path
    id="menu"
    d="M0,3 L24,3 L24,7 L0,7 L0,3 Z M0,10 L24,10 L24,14 L0,14 L0,10 Z M0,17 L24,17 L24,21 L0,21 L0,17 Z"
    :fill="iconColor"
  />
</template>

<script>
export default {
    name: 'MenuIcon',
    props: {
        iconColor: {
            type: String,
            default: 'currentColor'
        }
    }
};
</script>

<style scoped></style>
